
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import { ImpfstatistikOptions, ImpfstatistikOptionsPayload } from '@/store/statistik';
    import { VMenu } from '@/types/Components';

    @Component({
        computed: {
            ...mapState('impfstoff', ['impfstoffe']),
            ...mapState('impfstoff', { loadersImpfstoff: 'loaders' }),
            ...mapState('statistik', ['loaders']),
        },
        methods: {
            ...mapActions('statistik', ['exportExcel']),
            ...mapActions('impfstoff', ['loadImpfstoffe']),
        },
    })
    export default class Impfstatistik extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public loadImpfstoffe!: () => void;
        public exportExcel!: (payload: { options: ImpfstatistikOptionsPayload }) => void;

        public zeitraumMenu = false;
        public zeitraumErrorMessages: string[] = [];
        public search = '';

        public options: ImpfstatistikOptions = {
            impfstoffe: [],
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            jahrgang: [
                moment().subtract(9, 'years').format('YYYY'),
                moment().format('YYYY'),
            ],
        };

        public alleImpfstoffe = false;

        public get canExport(): boolean {
            const [vonZeitraum, bisZeitraum] = this.options.zeitraum;
            const [vonJahrgang, bisJahrgang] = this.options.jahrgang;

            return this.zeitraumErrorMessages.length === 0 &&
                (this.alleImpfstoffe || this.options.impfstoffe.length !== 0) &&
                !!vonZeitraum &&
                !!bisZeitraum &&
                !!vonJahrgang &&
                !!bisJahrgang &&
                (parseInt(bisJahrgang, 10) - parseInt(vonJahrgang, 10) >= 0);
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get maxJahrgang(): number {
            return moment().year();
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadImpfstoffe();
                this.zeitraumErrorMessages = [];
            }
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);

            this.zeitraumErrorMessages = [];

            const [von, bis] = this.options.zeitraum;
            if (Math.abs(moment(von).diff(moment(bis), 'days')) > 365) {
                this.zeitraumErrorMessages.push('Zeitraum darf nicht mehr als 365 Tage überschreiten.');
            }
        }

        public onClickExport(): void {
            const options: ImpfstatistikOptionsPayload = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            if (this.alleImpfstoffe) {
                delete options.impfstoffe;
            }

            this.exportExcel({ options });
        }
    }
